import { ArrowUpRight, CheckCircle, WarningCircle } from "@phosphor-icons/react";

import type { MetricCardProps } from "./index.types";

export function MetricCard({ metric }: MetricCardProps) {
  return (
    <article className={`metric-card status-${metric.status}`}>
      <div className="metric-card-heading">
        {metric.status === "healthy" ? <CheckCircle size={18} /> : <WarningCircle size={18} />}
        <span>{metric.label}</span>
        <ArrowUpRight className="metric-arrow" size={15} />
      </div>
      <strong>{metric.isLowerBound ? `${metric.value}+` : metric.value.toLocaleString("tr-TR")}</strong>
      <small>{metric.detail}</small>
    </article>
  );
}
